import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';

const Footer = () => {
  const { t } = useLanguage();
  
  return (
    <footer className="bg-[#1B2A4A] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <div className="mb-6">
              <h3 className="text-2xl font-bold text-[#D4A017] mb-2" style={{ fontFamily: 'Pacifico, serif' }}>
                Maalow
              </h3>
              <span className="text-white/80 font-medium text-sm">Consulting Services</span>
            </div>
            <p className="text-white/70 text-sm leading-relaxed mb-6">
              {t('footer.tagline')}
            </p>
            <div className="space-y-3">
              <div className="flex items-start space-x-3 text-white/70 text-sm">
                <i className="ri-map-pin-line w-5 h-5 flex items-center justify-center text-[#D4A017] mt-0.5"></i>
                <span>N/75 Hann Maristes 2<br />Dakar, Sénégal</span>
              </div>
              <div className="flex items-center space-x-3 text-white/70 text-sm">
                <i className="ri-mail-line w-5 h-5 flex items-center justify-center text-[#D4A017]"></i>
                <a href="mailto:hq@maalow.com" className="hover:text-[#D4A017] transition-colors cursor-pointer">
                  hq@maalow.com
                </a>
              </div>
            </div>
          </div>

          {/* Institutional Consulting */}
          <div>
            <h4 className="text-base font-semibold mb-4 text-[#D4A017]">{t('footer.services.institutional')}</h4>
            <ul className="space-y-2.5 text-white/70 text-sm">
              <li>
                <Link to="/conseil-institutionnel" className="hover:text-[#D4A017] transition-colors cursor-pointer">
                  E-Government Solutions
                </Link>
              </li>
              <li>
                <Link to="/conseil-institutionnel" className="hover:text-[#D4A017] transition-colors cursor-pointer">
                  National Registries
                </Link>
              </li>
              <li>
                <Link to="/conseil-institutionnel" className="hover:text-[#D4A017] transition-colors cursor-pointer">
                  Sovereign Cloud
                </Link>
              </li>
              <li>
                <Link to="/conseil-institutionnel" className="hover:text-[#D4A017] transition-colors cursor-pointer">
                  Data Governance
                </Link>
              </li>
              <li>
                <Link to="/conseil-institutionnel" className="hover:text-[#D4A017] transition-colors cursor-pointer">
                  EPC+F Projects
                </Link>
              </li>
            </ul>
          </div>

          {/* Digital Studio */}
          <div>
            <h4 className="text-base font-semibold mb-4 text-[#D4A017]">{t('footer.services.studio')}</h4>
            <ul className="space-y-2.5 text-white/70 text-sm">
              <li>
                <Link to="/studio-digital" className="hover:text-[#D4A017] transition-colors cursor-pointer">
                  Mobile Apps (Flutter)
                </Link>
              </li>
              <li>
                <Link to="/studio-digital" className="hover:text-[#D4A017] transition-colors cursor-pointer">
                  Web Platforms (Next.js)
                </Link>
              </li>
              <li>
                <Link to="/studio-digital" className="hover:text-[#D4A017] transition-colors cursor-pointer">
                  Analytics Dashboards
                </Link>
              </li>
              <li>
                <Link to="/studio-digital" className="hover:text-[#D4A017] transition-colors cursor-pointer">
                  Offline-First Solutions
                </Link>
              </li>
            </ul>
          </div>

          {/* Navigation & Legal */}
          <div>
            <h4 className="text-base font-semibold mb-4 text-[#D4A017]">{t('footer.company.title')}</h4>
            <ul className="space-y-2.5 text-white/70 text-sm mb-6">
              <li>
                <Link to="/equipe" className="hover:text-[#D4A017] transition-colors cursor-pointer">
                  {t('footer.company.team')}
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-[#D4A017] transition-colors cursor-pointer">
                  {t('footer.company.contact')}
                </Link>
              </li>
            </ul>
            <div className="text-white/50 text-xs space-y-1">
              <p>NINEA: 004592847</p>
              <p>RCCM: SN.DKR.2025.B.6799</p>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <p className="text-white/50 text-sm">
            {t('footer.copyright')}
          </p>
          <div className="flex items-center space-x-6">
            <a 
              href="https://readdy.ai/?origin=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-white/50 hover:text-[#D4A017] transition-colors text-sm cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;